import React from "react";

interface RemoveButtonProps {
    onRemove: () => void;
}

const RemoveButton: React.FC<RemoveButtonProps> = ({ onRemove }) => {
    return (
        <button className={"danger"} onClick={onRemove}>
            Remove
        </button>
    );
};

export default RemoveButton;
